import { render, staticRenderFns } from "./ExtraFieldsForm.vue?vue&type=template&id=5f7c789a&"
import script from "./ExtraFieldsForm.vue?vue&type=script&lang=js&"
export * from "./ExtraFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports